import { Injectable } from '@angular/core';
import { Establecimiento, PuntoEmisionModel } from '../data-access';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { filter, shareReplay, tap } from 'rxjs/operators';
import { StorageService } from '@core/utils';

@Injectable()
export class EstablecimientosService {
  private _establecimientos = new BehaviorSubject<Establecimiento[]>([]);
  readonly establecimientos$ = this._establecimientos.asObservable().pipe(
    filter((data) => data.length > 0),
    shareReplay(1)
  );

  private _establecimientosBodegas = new BehaviorSubject<Establecimiento[]>([]);
  readonly establecimientosBodegas$ = this._establecimientosBodegas.asObservable().pipe(
    filter((data) => data.length > 0),
    shareReplay(1)
  );

  private readonly ESTABLECIMIENTO = 'establecimiento';
  constructor(private _http: HttpClient, private _storage: StorageService) {}

  set establecimientos(data: Establecimiento[]) {
    this._establecimientos.next(data);
  }

  set codEstablecimiento(value: number) {
    this._storage.set(this.ESTABLECIMIENTO, value);
  }

  set establecimientosBodegas(data: Establecimiento[]) {
    this._establecimientosBodegas.next(data);
  }

  getCodEstablecimiento() {
    return new Promise<number>((resolve, reject) => {
      this._storage.get(this.ESTABLECIMIENTO).then((value: number) => {
        if (value) {
          resolve(value);
        }
        reject(null);
      });
    });
  }

  getMisEstablecimientos() {
    return this._http
      .get<Establecimiento[]>(`${environment.API_URL}/Establecimientos`)
      .pipe(
        tap((establecimientos) => {
          this.codEstablecimiento = establecimientos[0]?.CodEstablecimiento;
          this.establecimientos = establecimientos;
        })
      );
  }

  resetEstablecimientos() {
    this.establecimientos = [];
  }

  getMisEstablecimientosBodegas() {
    return this._http
      .get<Establecimiento[]>(`${environment.API_URL}/EstablecimientosBodegas`)
      .pipe(
        tap((establecimientosBodegas) => {
          this.codEstablecimiento = establecimientosBodegas[0]?.CodEstablecimiento;
          this.establecimientosBodegas = establecimientosBodegas;
        })
      );
  }

  getPuntosEmision() {
    return this._http
      .get<PuntoEmisionModel[]>(`${environment.API_URL}/PuntosEmision`)
      .pipe(shareReplay(1));
  }
}
